module.exports = __webpack_public_path__ + "img/pi-3.39fa3271.png";